var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
var BoothPopover = /** @class */ (function (_super) {
    __extends(BoothPopover, _super);
    function BoothPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isShow = false;
        return _this;
    }
    /* methods */
    // el dom元素
    BoothPopover.prototype.textRange = function (el) {
        var textContent = el;
        var lineHeight = getComputedStyle(textContent).lineHeight.replace('px', '');
        var trueHeight = textContent.scrollHeight;
        // scrollHeight包括边距等因素，所以多加2
        return +lineHeight * 2 + 2 < trueHeight;
    };
    BoothPopover.prototype.isShowToltip = function (e) {
        this.isShow = this.textRange(e.target);
    };
    BoothPopover.prototype.hideTip = function () {
        this.isShow = false;
    };
    __decorate([
        Prop({
            type: Object,
            default: function () { },
        })
    ], BoothPopover.prototype, "booth", void 0);
    BoothPopover = __decorate([
        Component
    ], BoothPopover);
    return BoothPopover;
}(Vue));
export default BoothPopover;
